<template>
  <a-modal
      title="文案库选择"
      :visible="isShow"
      @ok="submit"
      @cancel="isShow = false"
      destroyOnClose
  >
    <a-spin :spinning="spinning">
      <a-table :columns="columns" :data-source="dataList" :pagination="false" :row-selection="rowSelection">
        <!--        <a-radio name="expandIco" :value="props" slot="expandIco" slot-scope="props">-->
        <!--        </a-radio>-->
      </a-table>
      <my-pagination
          ref="MyPagination"
          @change="searchData"
          :total="totalCount"
          v-if="isShow"
      ></my-pagination>
    </a-spin>
  </a-modal>
</template>
<script>

const columns = [
  {
    title: '文案ID',
    dataIndex: 'id',
    width: 100
  },
  {
    title: ()=>this.$t('message.txtManagement.tableTitle2'),
    dataIndex: 'm_name_orgin',
    width: 200
  },
  {
    title: '渠道',
    dataIndex: 'm_channel',
    width: 80
  },
  {
    title: '内容',
    dataIndex: 'm_content',
  },
  {
    title: '创建人',
    dataIndex: 'create_user',
    width: 100
  },
  {
    title: '创建时间',
    dataIndex: 'create_time',
  },

];

import utils from "@/utils";
import MyPagination from "@/components/MyPagination";
import materialLibrary from "@/interface/pages/material/materialLibrary";
export default {
  name: "textLibrarySelectModal",
  components: {
    MyPagination
  },
  props: {},
  data() {
    return {
      size: "large",
      isShow: false,
      spinning: false,
      labelCol: {
        span: localStorage.getItem('i18n').startsWith('zh') ? 4 : 6
      },
      wrapperCol: {
        span: localStorage.getItem('i18n').startsWith('zh') ? 18 : 16
      },
      columns,
      totalCount: 0,
      selectData:null,
      dataList:[]
    };
  },
  mounted() {
    utils.languageChange(this, {labelCol: 6, wrapperCol: 16}, {labelCol: 4, wrapperCol: 18})
  },
  methods: {
    showModal(tag) {
      this.isShow = true;
    },

    submit() {
      this.$emit('changeCopyWrite',this.selectData.m_content)
      this.isShow = false
    },

    async searchData() {
      this.spinning = true;
      const {data: res} = await materialLibrary.getTableData(this, {
        params: {
          current:this.$refs.MyPagination.pagination.curPage,
          size:this.$refs.MyPagination.pagination.pageSize,
          type:'text'
        },
      });
      this.spinning = false;
      if (res.code === "200") {
        this.dataList = res.data;
        this.totalCount = res.totalCount;
      } else {
        this.$message.error(res.message);
      }
    },
  },
  computed: {
    rowSelection() {
      return {
        type:"radio",
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectData = selectedRows[0]
        },
        getCheckboxProps: record => ({
          props: {
            name: record.name,
          },
        }),
      };
    },
  },
  watch: {},
};
</script>

<style scoped lang="less">
::v-deep .ant-modal {
  width: 36% !important;
  min-width: 1200px;
}
</style>
